import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "h-screen flex flex-col justify-around p-6" };
const _hoisted_2 = { class: "flex flex-row justify-center items-center" };
const _hoisted_3 = { class: "flex flex-col" };
const _hoisted_4 = { class: "text-primary font-bold text-xl" };
const _hoisted_5 = { class: "text-primary font-semi-bold text-xs" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "mt-4 text-center font-semibold text-primary text-lg" };
const _hoisted_8 = { class: "mt-2 flex justify-center" };
const _hoisted_9 = { class: "text-center font-semibold text-primary text-lg" };
const _hoisted_10 = { class: "mt-2 items-center px-10" };
const _hoisted_11 = { class: "flex flex-row items-center justify-center" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-sign-out-alt mr-2" }, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-home mr-2" }, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_avatar = _resolveComponent("avatar");
    const _component_work_space_dropdown = _resolveComponent("work-space-dropdown");
    const _component_MobileLanguageSelector = _resolveComponent("MobileLanguageSelector");
    const _component_Button = _resolveComponent("Button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_avatar, {
                class: "mr-5 h-11 w-11",
                "round-size": "full",
                src: `https://picsum.photos/seed/${_ctx.currentUser.username}/300/300`
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentUser.username), 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.currentUser.email), 1)
            ])
        ]),
        _createElementVNode("div", null, [
            ((!$setup.currentRoute.meta.isAdmin || $setup.currentRoute.name === 'Files') && $setup.currentRoute.name !== 'Selection')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('misc.actions.switchVault')), 1),
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_work_space_dropdown, {
                            onCloseMenu: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('closeMenu')))
                        })
                    ])
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('misc.actions.pickLanguage')), 1),
            _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_MobileLanguageSelector)
            ])
        ]),
        _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Button, {
                colored: "",
                class: "px-3 w-30 mr-1",
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('doLogout')))
            }, {
                default: _withCtx(() => [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('misc.actions.logout')), 1)
                ]),
                _: 1
            }),
            _createVNode(_component_Button, {
                class: "px-3 w-30 ml-1",
                colored: "",
                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('goToSelection')))
            }, {
                default: _withCtx(() => [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('misc.actions.home')), 1)
                ]),
                _: 1
            })
        ])
    ]));
}
